// extracted by mini-css-extract-plugin
export default {"aiAssistantContainer":"AiAssistant_aiAssistantContainer__bT3Ho","mainContent":"AiAssistant_mainContent__kV++t","aiAssistantMain":"AiAssistant_aiAssistantMain__SsNES"};